import React from 'react';
import { noop, isEmpty, isNil, get } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { GLOBAL_LABELS } from 'constants/common';
import { button as Button } from 'modules/button';
import { Icon } from 'modules/icon-bank';
import { CREDIT_CARD_TYPE } from 'constants/entity-names';

// card type icons
const CARD_TYPE_ICON = {
    [ CREDIT_CARD_TYPE.CREDIT_VISA ]: 'visaCard',
    [ CREDIT_CARD_TYPE.MASTER_CARD ]: 'masterCard',
    [ CREDIT_CARD_TYPE.AMERICAN_EXPRESS ]: 'amexCard',
    [ CREDIT_CARD_TYPE.DISCOVER ]: 'discoverCard',
    [ CREDIT_CARD_TYPE.DEBIT_VISA ]: 'visaCard',
    [ CREDIT_CARD_TYPE.DEBIT_MASTER_CARD ]: 'masterCard'
};

const ConfirmView = ( props ) => {

    const { type } = props;

    if( 'paymentInfo' ===  type ) {
        
        return (
            <div className='ui-payment-card'>
                <div className='ui-payment-card__text'>
                    { getLabel( GLOBAL_LABELS.DISPLAY_TEXT_LAST_FOUR_DIGITS_OF_CREDIT_CARD ) }
                </div>
                <div className='ui-payment-card__type'>
                    <div className='ui-payment-card__type__icon'>
                        <Icon id={ CARD_TYPE_ICON[ props.card.type ] } />
                    </div>
                    <div className='ui-payment-card__type__value'>
                        { get( props, 'card.lastDigits', null ) }
                    </div>
                </div>
            </div>
        );
    } else if( 'address' === type ) {

        return (
            <div className='ui-shipping-card'>
                <div className='ui-shipping-card__type'>
                    { props.address.type }
                </div>
                <div className='ui-shipping-card__type__value'>
                    { props.address.value }
                </div>
            </div>
        );
        
    } else {

        return(
            <></>
        );
    }
};


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { confirmOverlay as ConfirmOverlay } from 'ui/views/widgets/confirmOverlay';
 *
 * // render
 * <ConfirmOverlay propName='propValue'/>
 */
export const confirmOverlay = ( props ) => {

    const { confirmViewConfig = {} } = props;

    const bodyClass = classnames( 'ui-confirm-overlay__body', {
        'ui-confirm-overlay__body--not-center-align': ! isEmpty( confirmViewConfig )
    } );

    return (
        <div className='ui-confirm-overlay'>

            {/* head */}
            <div className='ui-confirm-overlay__head'>

                {/* title */}
                <div className='ui-confirm-overlay__head__title'>
                    { ! isEmpty( props.title ) ? props.title: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_CONFIRMATION ) }
                </div>

                {/* close button */}
                <div className='ui-confirm-overlay__head__close' onClick={ () => props.onNoClick() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>
            </div>

            {/* body */}
            <div className={ bodyClass }>

                {/* check if icon is not null, display icon in this case */}
                {
                    ! isNil( props.iconName ) && (
                        <div className='ui-confirm-overlay__body__icon'>
                            <Icon name='danger' width='40' height='40' />
                        </div>
                    )
                }
                <div className='ui-confirm-overlay__body__description'>
                    <div className='ui-confirm-overlay__body__description__text'>
                        {
                            ! isEmpty( props.message ) ? props.message : getLabel( GLOBAL_LABELS.DISPLAY_TEXT_ARE_YOU_SURE )
                        }
                    </div>

                    { !isEmpty( confirmViewConfig ) && (
                        <ConfirmView
                            { ...confirmViewConfig }
                            />
                    ) }

                {/* {! isEmpty( props.extraMsg ) && (<div  className='ui-confirm-overlay__body__description__content' >
                   <div className='ui-confirm-overlay__body__description__content__title'> { props.extraMsg.type } </div>
                    <div  className='ui-confirm-overlay__body__description__content__value'>
                    { props.extraMsg.msg }
                    </div>
                     </div>)} */}
                </div>

                
            </div>

            <div className='ui-confirm-overlay__actions'>
                <Button
                    className='ui-confirm-overlay__actions__item ui-confirm-overlay__actions__item--no'
                    title={ props.cancelButtonLabel || { refId: '', value: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_NO ) } }
                    outline={ true }
                    size='large'
                    onClick={ () => props.onNoClick() }
                />

                <Button
                    className='ui-confirm-overlay__actions__item ui-confirm-overlay__actions__item--yes'
                    title={ props.confirmButtonLabel || { refId: '', value: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_YES ) } }
                    size='large'
                    onClick={ () => props.onYesClick() }
                />
            </div>
        </div>
    );
};

// set display name
confirmOverlay.displayName = 'confirmOverlay';

// set default props
confirmOverlay.defaultProps = {
    message: null,
    iconName: null,
    onYesClick: noop,
    onNoClick: noop,
    confirmButtonLabel: null,
    cancelButtonLabel: null,
};

// prop types
confirmOverlay.propTypes = {};
